import { Box, FlexBox } from '@trmediaab/zebra';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { PageTitle, Preamble } from '~/components/Elements';
import Img from '~/components/Img';
import PlainText from '~/components/PlainText';
import TwoColumnLayout from '~/components/TwoColumnLayout';
import { authorPropType } from '~/utils/prop-types';

import Byline from './Byline';

const AuthorImage = styled(Img)`
  display: block;
  height: auto;
  max-width: 100%;
`;

const Header = ({
  headline,
  pubDate,
  preamble,
  author,
  quoteHeadline,
  showAuthor,
}) => (
  <header>
    <TwoColumnLayout
      gutter={false}
      aside={
        showAuthor && author != null ? (
          <FlexBox
            flex={1}
            height="100%"
            justifyContent="flex-start"
            alignItems="flex-end"
          >
            {author.image && (
              <Box pl="4" width={{ _: 120, md: 200 }}>
                <AuthorImage image={author.image} width={200} />
              </Box>
            )}
            <Byline author={author} pubDate={pubDate} variant="headerMobile" />
          </FlexBox>
        ) : undefined
      }
    >
      <PageTitle>
        {quoteHeadline && showAuthor && author != null
          ? `${author.firstname} ${author.lastname}: "${headline}"`
          : headline}
      </PageTitle>
      {preamble && (
        <Preamble className="seo-paywall">
          <PlainText>{preamble}</PlainText>
        </Preamble>
      )}
      {showAuthor && author != null && (
        <Byline author={author} pubDate={pubDate} variant="headerDesktop" />
      )}
    </TwoColumnLayout>
  </header>
);

Header.propTypes = {
  headline: PropTypes.string.isRequired,
  pubDate: PropTypes.string.isRequired,
  preamble: PropTypes.string,
  author: authorPropType,
  quoteHeadline: PropTypes.bool.isRequired,
  showAuthor: PropTypes.bool.isRequired,
};

export default Header;
